// Overdue debts list — /debts/overdue (manager+)
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { apiGet } from "@/lib/api/client";

interface OverdueRow {
  customerId: string;
  name: string;
  phone: string;
  balance: string;
  earliestDue?: string;
}

function fmtVND(n: string) {
  return new Intl.NumberFormat("vi-VN").format(parseFloat(n) || 0) + " ₫";
}

export function OverdueListPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["debts", "overdue"],
    queryFn: () => apiGet<OverdueRow[]>("/v1/debts/overdue"),
  });

  const rows = data ?? [];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Công nợ quá hạn</h1>
        <span className="text-sm text-muted-foreground">{rows.length} khách hàng</span>
      </div>

      <div className="overflow-x-auto rounded-lg border">
        <table className="w-full text-sm">
          <thead className="border-b bg-muted/50">
            <tr>
              {["Tên", "SĐT", "Số nợ", "Đến hạn sớm nhất", ""].map((h) => (
                <th key={h} className="px-4 py-3 text-left font-medium text-muted-foreground">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr><td colSpan={5} className="py-8 text-center text-muted-foreground">Đang tải...</td></tr>
            )}
            {!isLoading && rows.length === 0 && (
              <tr><td colSpan={5} className="py-8 text-center text-green-600 font-medium">Không có công nợ quá hạn!</td></tr>
            )}
            {rows.map((r) => (
              <tr key={r.customerId} className="border-b last:border-0 hover:bg-muted/30">
                <td className="px-4 py-3 font-medium">{r.name || "—"}</td>
                <td className="px-4 py-3 font-mono">{r.phone}</td>
                <td className="px-4 py-3 font-bold text-destructive">{fmtVND(r.balance)}</td>
                <td className="px-4 py-3 text-muted-foreground">
                  {r.earliestDue
                    ? new Date(r.earliestDue).toLocaleDateString("vi-VN")
                    : "—"}
                </td>
                <td className="px-4 py-3">
                  <Link
                    to={`/customers/${r.customerId}` as any}
                    className="text-primary hover:underline text-xs"
                  >
                    Xem khách hàng
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
